module.exports = __webpack_public_path__ + "static/media/banner_11.eba6bdbc.jpg";